import React, { ReactNode } from 'react';
import styles from './SimpleInfo.module.scss';
import { Stack } from 'new/elements/Stack';
import { Typography } from '@mui/material';

interface SimpleInfoProps {
  label: string;
  value: string | ReactNode;
  direction?: 'flex-start' | 'flex-end';
}

export const SimpleInfo = (props: SimpleInfoProps) => {
  const { label, value, direction } = props;
  return (
    <Stack justifyContent={direction}>
      <Typography
        sx={{ alignSelf: direction, display: 'flex' }}
        className={styles.label}
        variant="body3"
      >
        {label}
      </Typography>
      <Typography
        sx={{ alignSelf: direction, display: 'flex' }}
        className={styles.value}
        variant="caption"
      >
        {value}
      </Typography>
    </Stack>
  );
};

SimpleInfo.defaultProps = {
  direction: 'flex-start',
};
